import typography from"./typography.module.css";const labelMedium=typography.labelMedium;export{labelMedium};